import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import App from "./App";
import reportWebVitals from './reportWebVitals';
import getBrowserLanguage from "./utils/languageDetector";

// Detect browser language and set it in i18n
const detectedLanguage = getBrowserLanguage();
i18n.changeLanguage(detectedLanguage);

// Function to dynamically load gtag.js and initialize it
const loadGtagScript = () => {
  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-16963577384'; // Replace with your Google Ads ID
  script.async = true;

  // Append the script to the <head>
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', 'AW-16963577384'); // Replace with your Google Ads ID
};

// Load the gtag script before rendering the app
loadGtagScript();

// Create the root and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();